import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ReviewOutputFilesDialogData } from 'src/app/models/outputs-collections/preview-output-files/dialog-data';
import { FileEntry } from 'src/app/models/outputs-collections/preview-output-files/file-entry';

@Component({
  selector: 'app-review-output-files-dialog',
  templateUrl: './review-output-files-dialog.component.html',
  styleUrls: ['./review-output-files-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ReviewOutputFilesDialogComponent {
  readonly displayedColumns: string[] = ['filename', 'hasFile', 'reviewState', 'released'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: ReviewOutputFilesDialogData,
    public readonly dialogRef: MatDialogRef<ReviewOutputFilesDialogComponent>,
  ) {}

  get entries(): FileEntry[] {
    return this.data.response.entries;
  }

  hasFile(entry: FileEntry): boolean {
    return entry.file != null;
  }

  reviewStateLabel(entry: FileEntry): string {
    return entry.file?.internalReviewState ?? '—';
  }

  releasedLabel(entry: FileEntry): string {
    if (entry.file == null) return '—';
    return entry.file.released ? 'Yes' : 'No';
  }
}
